import { createContext } from "react";
//TODO: improve this dependency
import { application } from "../../_runtime/bootstrap";
import { IServiceProvider } from "../../configuration/modules/modules.types";

//This is the React context that will hold the DI container (abusing the term, but IoC Container in an application is the one responsible to manage service instances dependencies and its injection ) to be shared across the application
//The context and provider allows the component tree to access the application service provider
//The service provider is created in the application startup. There you can add the services you want to use in the application

//1. Get the service provider from the application
const provider = application.getServiceProvider();

//2. Create a new context for the service provider
export const ContainerContext = createContext<IServiceProvider>(provider);

//3. Define a component that provides the container to its children
export const ContainerProvider = ({
  container,
  children,
}: {
  container: IServiceProvider;
  children: any;
}) => {
  return (
    <ContainerContext.Provider value={container}>
      {children}
    </ContainerContext.Provider>
  );
};
